import { render, staticRenderFns } from "./UserMenu.vue?vue&type=template&id=8ef766a4&scoped=true"
import script from "./UserMenu.vue?vue&type=script&lang=js"
export * from "./UserMenu.vue?vue&type=script&lang=js"
import style0 from "./UserMenu.vue?vue&type=style&index=0&id=8ef766a4&lang=less&scoped=true"
import style1 from "./UserMenu.vue?vue&type=style&index=1&id=8ef766a4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef766a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ef766a4')) {
      api.createRecord('8ef766a4', component.options)
    } else {
      api.reload('8ef766a4', component.options)
    }
    module.hot.accept("./UserMenu.vue?vue&type=template&id=8ef766a4&scoped=true", function () {
      api.rerender('8ef766a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tools/UserMenu.vue"
export default component.exports